import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Route,
  withRouter,
} from 'react-router-dom';
import { Button, Layout } from 'antd';
import { useTranslation } from 'react-i18next';

import './index.less';

import Context from '../../context';
import PageHeaderBar from '../../components/PageHeaderBar';
import CapacitySubscriptionsTable from '../../components/CapacitySubscriptionsTable';
import CapacitySubscription from '../../components/CapacitySubscription';
import { hasCapacityWritePermission } from '../Capacity';

const CapacitySubscriptions = ({ history }) => {
  const {
    currentUser,
    selectedMarketPartyId,
    isAdmin,
  } = useContext(Context);
  const [latestCapacitySubscription, setLatestCapacitySubscription] = useState(null);
  const { t } = useTranslation();

  const canCreateSubscriptions = isAdmin(true) || hasCapacityWritePermission({ currentUser, selectedMarketPartyId });


  const handleCloseCapacitySubscription = (newSubscription) => {
    if (newSubscription !== undefined) {
      setLatestCapacitySubscription(newSubscription);
    }
    history.push('/capacitysubscriptions');
  };

  const handleNewSubscriptionClick = () => {
    history.push('/capacitysubscriptions/new');
  };

  const renderButtons = () => (
    canCreateSubscriptions
      ? (
        <Button
          className="page__header__buttons__subscription"
          type="primary"
          onClick={handleNewSubscriptionClick}
        >
          {t('capacity.button.newCapacitySubscription')}
        </Button>
      )
      : null
  );

  const renderCapacitySubscription = () => (
    canCreateSubscriptions ? (
      <CapacitySubscription onClose={handleCloseCapacitySubscription} />
    ) : null
  );

  return (
    <>
      <PageHeaderBar
        title={t('capacitySubscription.title.list')}
        actionItems={renderButtons()}
      />
      <Layout.Content className="layout__container__page__content capacitysubscriptions">
        <CapacitySubscriptionsTable
          includeTimestamps
          newCapacitySubscription={latestCapacitySubscription}
          stackedHeader
        />
      </Layout.Content>
      <Route
        path="/capacitysubscriptions/new"
        render={renderCapacitySubscription}
      />
    </>
  );
};

CapacitySubscriptions.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

CapacitySubscriptions.displayName = 'CapacitySubscriptions';

export default withRouter(CapacitySubscriptions);
export {
  CapacitySubscriptions as PureComponent,
};
